import { render, staticRenderFns } from "./DialogService.vue?vue&type=template&id=cc4d2cba&scoped=true"
import script from "./DialogService.vue?vue&type=script&lang=ts"
export * from "./DialogService.vue?vue&type=script&lang=ts"
import style0 from "./DialogService.vue?vue&type=style&index=0&id=cc4d2cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4d2cba",
  null
  
)

export default component.exports